import styled from 'styled-components';

import { PaginationButtons } from '../../../display/tables/components/PaginationButtons';
import { MainButton } from '../../../inputs/buttons/MainButton';

// P15 rework v2 (2026-07-09, feedback usuario) — composición calcada 1:1 de
// `RelatesCommunicationModal/styles.ts`: `Container` inerte + `ButtonContainer`
// con Volver | PaginationButtonsStyled | Vincular (la paginación vive en el
// footer del modal, NO dentro de la tabla — la interna se apaga vía
// `showButtonsPagination={false}`).

// Paridad de TAMAÑO con `RelatesCommunicationModal` (feedback usuario
// 2026-07-10): el `ModalContainer` no fija ancho (su default `95vw+rem` es
// CSS inválido → `width:auto` al contenido, con tope `max-width: 95vw`).
// El modal de comunicaciones se ve a pantalla completa porque su tabla
// (~15 columnas) empuja hasta ese tope; la nuestra (6 columnas) se
// encogería. Fijamos el contenido al MISMO tope efectivo: 95vw menos el
// padding `spacing.xl` (4rem) por lado del ModalContainer.
export const Container = styled.div`
  width: calc(95vw - 8rem);
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  /* Aire entre la última fila y el pie (feedback usuario 2026-07-10): en
     comunicaciones lo pone la PROPIA tabla (InputRadioDefaultTable →
     TableContainerStyled con padding vertical spaces.m); InputRadioTagTable
     no lo trae (su aire inferior era su paginador interno, aquí apagado) →
     mismo token spaces.m aquí para el mismo hueco. */
  margin-top: ${({ theme }) => theme.spaces.m}rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spaces.m}rem;
    justify-content: center;
  }
`;

export const MainButtonStyled = styled(MainButton)`
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    order: 2;
  }
`;

export const CloseButton = styled(MainButton)`
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    order: 2;
  }
`;

// Estado vacío (2026-07-10, feedback usuario): con 0 tramos elegibles la
// tabla quedaba en blanco bajo los headers, sin explicación. Mensaje bajo la
// tabla (key existente `modals:relateSegment.empty`).
export const EmptyMessage = styled.p`
  margin: ${({ theme }) => theme.spaces.m}rem 0 0;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.S};
  color: ${({ theme }) => theme.colors.greyDark};
`;

export const PaginationButtonsStyled = styled(PaginationButtons)`
  padding: 0;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
    order: 1;
    justify-content: center;
    align-items: center;
  }
`;
